import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';

interface Props {
  connector: ConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const ApiKeyConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;

  if (!inWriteMode) {
    return null;
  }

  return (
    <Box>
      <InputControl
        name="config.apiKey"
        label="API Key"
        formHandle={formHandle}
        updateOnly={!isNew}
        required={isNew}
      />
    </Box>
  );
};

export default ApiKeyConnector;
